/**
 * `MatjaraService::sendRequest()` turns a 404 from the store's product endpoint
 * into this message. It reaches the merchant unchanged, and it reaches them at
 * the worst moment: opening a section that was linked to a product the store
 * has since deleted is not something the merchant just did wrong, yet the
 * editor greeted them with an internal English string in an Arabic interface.
 */
export const MISSING_PRODUCT = "Matjara product ID not found";

export const MISSING_PRODUCT_NOTICE =
  "المنتج المرتبط بهذا القسم لم يعد موجوداً في المتجر. اختر منتجاً آخر.";

export const isMissingProductError = (error) =>
  String((error && error.message) || "").includes(MISSING_PRODUCT);
